import DashboardOutlinedIcon from '@mui/icons-material/DashboardOutlined';
import HourglassEmptyOutlinedIcon from '@mui/icons-material/HourglassEmptyOutlined';
import PendingActionsOutlinedIcon from '@mui/icons-material/PendingActionsOutlined';
import GroupOutlinedIcon from '@mui/icons-material/GroupOutlined';
import PersonAddAltOutlinedIcon from '@mui/icons-material/PersonAddAltOutlined';
import BusinessOutlinedIcon from '@mui/icons-material/BusinessOutlined';
import BadgeOutlinedIcon from '@mui/icons-material/BadgeOutlined';
import PaymentsOutlinedIcon from '@mui/icons-material/PaymentsOutlined';
import AccountBalanceWalletOutlinedIcon from '@mui/icons-material/AccountBalanceWalletOutlined';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import SupportAgentOutlinedIcon from '@mui/icons-material/SupportAgentOutlined';
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';
import ReceiptLongOutlinedIcon from '@mui/icons-material/ReceiptLongOutlined';
import GavelOutlinedIcon from '@mui/icons-material/GavelOutlined';
import PhotoFilterOutlinedIcon from '@mui/icons-material/PhotoFilterOutlined';

export const ICON_MAP = {
  dashboard: 'images/dashboardHigh.svg',
  addMember: 'images/addMemberr.svg',
  website: 'images/elements.svg',
  memberRequest: 'images/memberRequest.svg',
  documents: 'images/documents.svg',
  claims: 'images/claims.svg',
  memberSearch: 'images/membersearch.svg',
  viewMember: 'images/membersearch.svg',
  paymentRequest: 'images/allTransaction.svg',
  notifications: 'images/notifications.svg',
  helpDesk: 'images/helpDesk.svg',
  reports: 'images/reports.svg',
  settings: 'images/settings.svg',
  transactionHistory: 'images/transactionHistory.svg',
  allTransaction: 'images/allTransaction.svg',
  reminders: 'images/notifications.svg',
  expenses: 'images/allTransaction.svg',
  postGenerator: 'images/elements.svg',
  default: 'images/defaultIcon.svg',
};

export const PAGE_NAME_TO_ICON = {
  Dashboard: 'dashboard',
  'Add Member': 'addMember',
  Website: 'website',
  'Member Requests': 'memberRequest',
  Documents: 'documents',
  'Document Status Wise': 'documents',
  Claims: 'claims',
  'Member Search': 'memberSearch',
  'Active Members': 'viewMember',
  'All Members': 'viewMember',
  'Reference Tracking': 'memberSearch',
  'Help Desk': 'helpDesk',
  Communication: 'helpDesk',
  Reports: 'reports',
  Settings: 'settings',
  'Transaction History': 'transactionHistory',
  'All Transaction': 'allTransaction',
  'All Transactions': 'allTransaction',
  'Organisation Management': 'settings',
  'Organisation Members': 'viewMember',
  'Organisation Payment': 'paymentRequest',
  Reminders: 'reminders',
  'Renewal Reminders': 'reminders',
  Expenses: 'expenses',
  'Expense Management': 'expenses',
  'Expense Dashboard': 'expenses',
  'Expense Categories': 'expenses',
  'Expense Reports': 'expenses',
  'Post Generator': 'postGenerator',
  'Post Categories': 'postGenerator',
  'Post Templates': 'postGenerator',
  'In Progress': 'memberRequest',
  'Pending Approval': 'memberRequest',
  'New Registrations': 'memberRequest',
};

export const PAGE_MUI_ICONS = {
  Dashboard: DashboardOutlinedIcon,
  'In Progress': HourglassEmptyOutlinedIcon,
  'Pending Approval': PendingActionsOutlinedIcon,
  'All Members': GroupOutlinedIcon,
  'Active Members': GroupOutlinedIcon,
  'Add Member': PersonAddAltOutlinedIcon,
  'Organisation Management': BusinessOutlinedIcon,
  'Organisation Members': BadgeOutlinedIcon,
  'Organisation Payment': PaymentsOutlinedIcon,
  'All Transaction': AccountBalanceWalletOutlinedIcon,
  'All Transactions': AccountBalanceWalletOutlinedIcon,
  Documents: DescriptionOutlinedIcon,
  'Document Status Wise': DescriptionOutlinedIcon,
  'Help Desk': SupportAgentOutlinedIcon,
  Communication: SupportAgentOutlinedIcon,
  Reports: ReceiptLongOutlinedIcon,
  Settings: SettingsOutlinedIcon,
  Claims: GavelOutlinedIcon,
  Reminders: PendingActionsOutlinedIcon,
  'Renewal Reminders': PendingActionsOutlinedIcon,
  'Transaction History': AccountBalanceWalletOutlinedIcon,
  'Post Generator': PhotoFilterOutlinedIcon,
};

export const getAdminPath = (path) => {
  if (!path) return '/admin';
  if (path.startsWith('/admin')) return path;
  return `/admin${path}`;
};

export const getIconPath = (menu) => {
  const iconKey = menu?.icon || PAGE_NAME_TO_ICON[menu?.pageName] || 'default';
  return ICON_MAP[iconKey] || ICON_MAP.default;
};

export const flattenMenuPages = (groupedPages = {}, sectionOrder = []) => {
  const pages = [];
  sectionOrder.forEach((section) => {
    (groupedPages[section] || []).forEach((page) => pages.push(page));
  });
  return pages;
};

const BOTTOM_NAV_MAX = 4;

/** Short labels for bottom bar — full page names truncate on narrow screens. */
export const BOTTOM_NAV_SHORT_LABELS = {
  Dashboard: 'Home',
  'In Progress': 'Progress',
  'Pending Approval': 'Pending',
  'New Registrations': 'New',
  'Add Member': 'Add',
  'All Members': 'Members',
  'Active Members': 'Members',
  'Member Search': 'Search',
  'Member Requests': 'Requests',
  Documents: 'Documents',
  'Document Status Wise': 'Documents',
  Claims: 'Claims',
  'Organisation Management': 'Org',
  'Organisation Members': 'Org Members',
  'Organisation Payment': 'Org Pay',
  'All Transaction': 'Payments',
  'All Transactions': 'Payments',
  'Transaction History': 'History',
  'Help Desk': 'Help',
  Communication: 'Comms',
  Reports: 'Reports',
  Settings: 'Settings',
  Reminders: 'Reminders',
  'Renewal Reminders': 'Renewals',
  Expenses: 'Expenses',
  'Expense Management': 'Expenses',
  'Expense Dashboard': 'Expenses',
  'Expense Categories': 'Categories',
  'Expense Reports': 'Exp. Reports',
  'Post Generator': 'Posts',
  'Post Categories': 'Posts',
  'Post Templates': 'Templates',
  Website: 'Website',
  'Reference Tracking': 'Referrals',
};

export const getBottomNavLabel = (pageName) => {
  if (!pageName) return 'Menu';
  if (BOTTOM_NAV_SHORT_LABELS[pageName]) return BOTTOM_NAV_SHORT_LABELS[pageName];
  const words = pageName.trim().split(/\s+/);
  if (words.length === 1) {
    return pageName.length > 12 ? `${pageName.slice(0, 11)}…` : pageName;
  }
  const first = words[0];
  return first.length <= 10 ? first : `${first.slice(0, 9)}…`;
};

/** Pick diverse primary items: Dashboard first, then first page from each section. */
export const getBottomNavPages = (groupedPages = {}, sectionOrder = [], maxPrimary = BOTTOM_NAV_MAX) => {
  const allPages = flattenMenuPages(groupedPages, sectionOrder);
  if (allPages.length <= maxPrimary + 1) {
    return { primary: allPages, showMore: false };
  }

  const primary = [];
  const seenPaths = new Set();

  const addPage = (page) => {
    const path = getAdminPath(page?.path);
    if (!page || seenPaths.has(path) || primary.length >= maxPrimary) return;
    seenPaths.add(path);
    primary.push(page);
  };

  (groupedPages.DASHBOARD || []).forEach(addPage);

  sectionOrder.forEach((section) => {
    if (section === 'DASHBOARD') return;
    const sectionPages = groupedPages[section] || [];
    if (sectionPages.length > 0) addPage(sectionPages[0]);
  });

  allPages.forEach((page) => addPage(page));

  return { primary, showMore: true };
};

export const isMenuPathActive = (pathname, path) => {
  const adminPath = getAdminPath(path);
  if (pathname === adminPath) return true;
  if (adminPath === '/admin') {
    return pathname === '/admin' || pathname === '/admin/';
  }
  return pathname.startsWith(`${adminPath}/`);
};
